
import Input from "../components/form/Input.vue";
import Tags from "../components/Tags.vue";
import Button from "../components/buttons/Button.vue";
import { useRouter } from "vue-router";
import { defineComponent } from "vue";
import { useField, useForm } from "vee-validate";
import { buildAdvancedQuery } from "../utils/functions";
export default defineComponent({
  name: "Search",
  components: {
    Input,
    Tags,
    Button,
  },
  setup() {
    const router = useRouter();
    const { handleSubmit } = useForm();

    const { value: title } = useField("title");
    const { value: author } = useField("author");
    const { value: tags } = useField("tags");

    const handleSearch = handleSubmit((data) => {
      router.push(
        `/ksiazki?${buildAdvancedQuery(
          data.tags || [],
          data.author,
          data.title,
        )}`,
      );
    });

    return {
      title,
      author,
      tags,
      handleSearch,
    };
  },
});
